import { Image } from './logo.styles';
import DefaLogo from '../../assets/defa-logo.svg';
import CloudchargeLogo from '../../assets/cloudcharge-logo.svg';
export interface LogoProps {
    variant: 'defa' | 'cloudcharge';
    size?: number;
}
export function Logo({ variant, size = 48 }: LogoProps) {
    return (
        <>
            {variant === 'defa' ? (
                <Image src={DefaLogo} alt="Defa Logo" size={size} />
            ) : (
                <img src={CloudchargeLogo} alt="Cloudcharge Logo" width={size} height={size} />
            )}
        </>
    );
}
